export const environment = {
  production: true,
  buildId: '2578604369217761',
  configFile: 'config.json',
};
